// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__36QV4","colMin":"styles_colMin__2s74Y","colCheckbox":"styles_colCheckbox__51Xo3"};